var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCloseIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.739,
    height: 18.738,
    viewBox: "0 0 18.739 18.738",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#666}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_icon",
    transform: "translate(-33 -27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    width: 24,
    height: 2.5,
    className: "cls-1",
    rx: 1.25,
    transform: "rotate(45 -15.208 55.469)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    width: 24,
    height: 2.5,
    className: "cls-1",
    rx: 1.25,
    transform: "rotate(135 19.911 25.1)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close_icon.346a5f2d.svg";
export { ForwardRef as ReactComponent };